module.exports = __webpack_public_path__ + "static/media/icon-simulation-white.add5d1a1.svg";